export const ADMIN_LOAD_COMPANIES_REQUEST = 'admin/LOAD_COMPANIES_REQUEST';
export const ADMIN_LOAD_COMPANIES_SUCCESS = 'admin/LOAD_COMPANIES_SUCCESS';
export const ADMIN_LOAD_COMPANIES_FAILURE = 'admin/LOAD_COMPANIES_FAILURE';

export const ADMIN_LOAD_COMPANY_REQUEST = 'admin/LOAD_COMPANY_REQUEST';
export const ADMIN_LOAD_COMPANY_SUCCESS = 'admin/LOAD_COMPANY_SUCCESS';
export const ADMIN_LOAD_COMPANY_FAILURE = 'admin/LOAD_COMPANY_FAILURE';

export const ADMIN_LOAD_USERS_REQUEST = 'admin/LOAD_USERS_REQUEST';
export const ADMIN_LOAD_USERS_SUCCESS = 'admin/LOAD_USERS_SUCCESS';
export const ADMIN_LOAD_USERS_FAILURE = 'admin/LOAD_USERS_FAILURE';

export const ADMIN_LOAD_USER_REQUEST = 'admin/LOAD_USER_REQUEST';
export const ADMIN_LOAD_USER_SUCCESS = 'admin/LOAD_USER_SUCCESS';
export const ADMIN_LOAD_USER_FAILURE = 'admin/LOAD_USER_FAILURE';

export const ADMIN_LOGIN_AS_USER_REQUEST = 'admin/LOGIN_AS_USER_REQUEST';
export const ADMIN_LOGIN_AS_USER_SUCCESS = 'admin/LOGIN_AS_USER_SUCCESS';
export const ADMIN_LOGIN_AS_USER_FAILURE = 'admin/LOGIN_AS_USER_FAILURE';

export const ADMIN_LOGOUT_AS_USER = 'admin/LOGOUT_AS_USER';
